var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30222 13.1911L9.55556 14.4444L14 10L9.55556 5.55556L8.30222 6.80889L10.5956 9.11111H2V10.8889H10.5956L8.30222 13.1911ZM16.2222 2H3.77778C2.79111 2 2 2.8 2 3.77778V7.33333H3.77778V3.77778H16.2222V16.2222H3.77778V12.6667H2V16.2222C2 17.2 2.79111 18 3.77778 18H16.2222C17.2 18 18 17.2 18 16.2222V3.77778C18 2.8 17.2 2 16.2222 2Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.ba3c67c2f4820bbd61d887eaf5868b0d.svg";
export { ForwardRef as ReactComponent };